function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { SvgIcon } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var RadioChecked = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsxs(SvgIcon, _extends({
    "data-testid": "RadioCheckedIcon"
  }, props, {
    ref: ref,
    children: [/*#__PURE__*/_jsx("path", {
      d: "M12 1.5C6.20443 1.5 1.5 6.20443 1.5 12C1.5 17.7956 6.20443 22.5 12 22.5C17.7956 22.5 22.5 17.7956 22.5 12C22.5 6.20443 17.7956 1.5 12 1.5ZM12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0Z",
      fill: "currentColor",
      fillRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6 12C6 8.688 8.688 6 12 6C15.312 6 18 8.688 18 12C18 15.312 15.312 18 12 18C8.688 18 6 15.312 6 12Z",
      fill: "currentColor"
    })]
  }));
});
RadioChecked.displayName = 'RadioCheckedIcon';
export default RadioChecked;